import { createAction, props } from "@ngrx/store"
import { RoleModel } from "../Model/Role.model"


export const GET_ROLE_SUCC='[role] get role success'

export const getrolessuccess=createAction(GET_ROLE_SUCC,props<{rolelist:RoleModel}>())
